<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>For my father—who I lost this past year, I wish I had been as good to<br/>you as you were to me. Twenty-twenty hindsight can be a horrible<br/>and haunting thing. I can only hope and pray that you could see<br/>beyond my youth, see the man, and know in your heart<br/>I tried to be the best I could be.</p>
<p class="dedication">For Roxie—a cousin, now a sister, for enduring the unendurable,<br/>the loss of a child, it should happen to no one in the entire world.<br/>My heart is broken for you.</p>
<p class="dedication">For Maribeth—to the ghosts of youth, may we forever be haunted<br/>and happier for it.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4b277a5a